export default "__VITE_ASSET__DaA03hby__"